export default function (group) {
  const $masterGroupCheck = group.find(
    '[data-behaviour="export-check-group-master"]'
  )
  if (!$masterGroupCheck.prop('disabled')) {
    const $allGroups = group.find('tr.level_0 .export-account-check input')
    const $allCheckedGroups = group.find(
      'tr.level_0 .export-account-check input:checked'
    )

    return $masterGroupCheck.prop(
      'checked',
      $allGroups.length === $allCheckedGroups.length
    )
  }
}
